import React from 'react'
import * as R from 'ramda'

export const useTabScrollIntoView = (
  activeTab,
  { behavior = 'smooth', block = 'end' } = {},
) => {
  const ref = React.useRef()

  React.useLayoutEffect(() => {
    if (R.isNil(activeTab)) return

    const timeout = window.setTimeout(() => {
      ref?.current?.scrollIntoView({ behavior, block })
    }, 250)

    return () => {
      window.clearTimeout(timeout)
    }
  }, [activeTab, behavior, block, ref])

  return ref
}
